import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { LEGAL, LEGAL_ORDER } from "@/lib/legalContent";

export default function Footer() {
  const { t, lang } = useLang();
  const legal = LEGAL[lang];
  return (
    <footer className="mt-20 border-t-2 border-stone-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/betool-logo.png" alt="Betool" className="w-9 h-9 rounded-xl object-cover" />
            <span className="font-head font-black text-xl">Betool</span>
          </div>
          <p className="text-stone-500">{t("footer_tagline")}</p>
          <p className="text-xs text-stone-400 mt-3 max-w-xs">{t("earnings_note")}</p>
        </div>
        <div>
          <h4 className="font-bold mb-3">{t("footer_product")}</h4>
          <ul className="space-y-2 text-stone-600">
            <li><Link to="/pricing" className="hover:text-primary">{t("nav_pricing")}</Link></li>
            <li><Link to="/support" className="hover:text-primary">{t("nav_help")}</Link></li>
            <li><Link to="/auth?mode=signup" className="hover:text-primary">{t("signup")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold mb-3">{t("footer_legal")}</h4>
          <ul className="space-y-2 text-stone-600 columns-2">
            {LEGAL_ORDER.map((slug) => (
              <li key={slug}><Link to={`/legal/${slug}`} className="hover:text-primary text-sm" data-testid={`footer-legal-${slug}`}>{legal[slug].title}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-stone-400 pb-6 px-4">
        © {new Date().getFullYear()} Betool — {t("legal_review_note")}
      </div>
    </footer>
  );
}
